/**
 *
 * @module dustApplicationPayload
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../../exception/invalidArgumentException';

const {
    string
} = Check.assert;

/**
 *
 * @class DustApplicationPayload
 * @since 3.4.0
 * @desc describes the application environment
 * @note needs to be exposed on the API layer to be able to populate this - not currently implemented
 *
 */
export default class DustApplicationPayload {

    /**
     *
     * @access private
     * @param {String} [version='']
     * @param {String} [id='']
     * @param {String} [name='']
     *
     */
    constructor(version = '', id = '', name = '') {

        const errorMessage = {
            ctor: 'DustApplicationPayload(version, id, name)',
            get version() {
                return `${this.ctor} needs a versoin String`;
            },
            get id() {
                return `${this.ctor} needs an id String`;
            },
            get name() {
                return `${this.ctor} needs a name String`;
            }
        };

        string(version, errorMessage.version, InvalidArgumentException);
        string(id, errorMessage.id, InvalidArgumentException);
        string(name, errorMessage.name, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {String}
         * @desc Application version
         * @example 1.0
         *
         */
        this.version = version;

        /**
         *
         * @access private
         * @type {String}
         * @desc Application Id
         * @example com.espn.enterprise.sportscenterqa
         *
         */
        this.id = id;

        /**
         *
         * @access private
         * @type {String}
         * @desc Application name
         * @example Espn
         *
         */
        this.name = name;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/dust/dustApplicationPayload.js